module.exports = __webpack_public_path__ + "1b7cc9a5060b6a5ed252f6214de5505d.svg";